import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { cn } from "@omni/utils/styles";

import { useProductSliderContext } from "../productSlider.context";

const ProductSliderSkeletonComponent = () => {
    const { source, title } = useProductSliderContext();

    const productSourceIsRecent = source === ProductSliderSources.Recent;

    return (
        <div
            className={cn("tw:pb-2", {
                "tw:max-lg:w-dvw tw:max-lg:relative tw:max-lg:left-1/2 tw:max-lg:right-1/2 tw:max-lg:mx-[-50vw] tw:max-lg:bg-grey tw:rounded-2xl":
                    productSourceIsRecent
            })}
        >
            <div
                className={cn({
                    "tw:bg-grey tw:p-4 tw:md:p-6 tw:xs:mt-6 tw:rounded-lg":
                        productSourceIsRecent
                })}
            >
                <div
                    className={cn(
                        "tw:flex tw:mb-2 tw:justify-between tw:w-full"
                    )}
                >
                    {title && (
                        <h2 className={cn("mr-3 my-2 flex-shrink-1")}>
                            {title}
                        </h2>
                    )}
                </div>
                <div className={cn("tw:flex tw:items-center")}>
                    <div
                        className={cn(
                            "tw:text-primary tw:text-3xl tw:cursor-default tw:opacity-20 tw:hidden tw:md:block",
                            {
                                "tw:-translate-x-1/3": productSourceIsRecent
                            }
                        )}
                    >
                        <i className={cn(`las la-angle-left`)} />
                    </div>
                    <div
                        className={cn("tw:grow tw:flex", {
                            "tw:gap-2": productSourceIsRecent,
                            "tw:gap-5": !productSourceIsRecent
                        })}
                    >
                        <div
                            className={cn(
                                "tw:w-1/4 tw:aspect-2/3 tw:bg-grey-light tw:rounded-md"
                            )}
                        />
                        <div
                            className={cn(
                                "tw:w-1/4 tw:aspect-2/3 tw:bg-grey-light tw:rounded-md"
                            )}
                        />
                        <div
                            className={cn(
                                "tw:w-1/4 tw:aspect-2/3 tw:bg-grey-light tw:rounded-md"
                            )}
                        />
                        <div
                            className={cn(
                                "tw:w-1/4 tw:aspect-2/3 tw:bg-grey-light tw:rounded-md"
                            )}
                        />
                    </div>
                    <div
                        className={cn(
                            "tw:text-primary tw:text-3xl tw:cursor-default tw:opacity-20 tw:hidden tw:md:block",
                            {
                                "tw:translate-x-1/3": productSourceIsRecent
                            }
                        )}
                    >
                        <i className={cn(`las la-angle-right`)} />
                    </div>
                </div>
            </div>
            <div className="product-tile__list--skeleton"></div>
        </div>
    );
};

export { ProductSliderSkeletonComponent };
